export const config = { 
    BASEURL: 'https://admin.matangifoundation.org/api/',
    // BASEURL: 'http://localhost/matangi/public/api/',
    // BASEURL: 'https://matangi.appcoup.com/api/',
};